import { parseToken } from "@utils/token.utils";
import { selectAtom } from "jotai/utils";
import { sessionTokenAtom } from "./sessionToken.atom";

export const sessionUserAtom = selectAtom(sessionTokenAtom, (token) => {
  if (!token) return;
  return parseToken(token);
});
